<template lang="html">
  <v-layout column>
    <v-card>
      <v-master-detail-pane>
        <template slot="master">
          <v-load-nav-list title="Deliveries"
                           searchPrompt="Search Completed Load Transactions"
                           customGroupIcon="check_circle"
                           :groupedItems="deliveredLoadOpenInvoices"
                           :loading="loadingTransactions"
                           :accurateSince="accurateSince"
                           :loads="invoices"
                           :company="company"
                           @update:searchTerm="search = $event"
                           @refresh="loadCompanyTransactions(company.id)">

            <template slot="loadTile"
                      slot-scope="{ idx, load: txn }">

              <v-list-tile :key="`load_txn_${idx}_${txn.id}`"
                           @click="selectLoad(txn)"
                           :class="{'primary lighten-1': isSelectedLoad(txn)}"
                           :inactive="isSelectedLoad(txn)"
                           ripple avatar>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ loadGroupSponsorName(txn.load.tacticalInfo.loadGroup) }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title class="text--primary"
                                         v-if="bookedLoadNickname(txn.load)">
                    {{ bookedLoadNickname(txn.load) }}
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title class="text--primary">
                      <span v-if="txn.load.pickup">
                        {{ txn.load.pickup.when | formatTxDate}}
                      </span>
                    <span v-else-if="txn.load.tacticalInfo.scheduledPickupTime">
                        {{ 'txn.load.tacticalInfo.scheduledPickupTime | formatTxDate'}}
                      </span>
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title>
                    {{ txn.loadHumanId }}: ${{ txn.amount }} ({{ txn.status || '[status]' }})
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-chip :color="invoiceStatusIcon(txn).color"
                          text-color="white" small>
                    <v-icon>
                      {{ invoiceStatusIcon(txn).icon }}
                    </v-icon>
                  </v-chip>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider :key="`load_txn_divider_${idx}_${txn.id}`"/>
            </template>

            <template slot="groupedItemsTile"
                      slot-scope="{ idx: iidx, item: status, items: txns }">

              <template v-for="(txn, idx) in txns">

                <v-list-tile :key="`delivered_load_txn_${iidx}_${idx}_${txn.id}`"
                             @click="selectLoad(txn)"
                             :class="{'primary lighten-1': isSelectedLoad(txn)}"
                             :inactive="isSelectedLoad(txn)"
                             ripple avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ loadGroupSponsorName(txn.load.tacticalInfo.loadGroup) }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary"
                                           v-if="bookedLoadNickname(txn.load)">
                      {{ bookedLoadNickname(txn.load) }}
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title class="text--primary">
                      <span v-if="txn.load.pickup">
                        {{ txn.load.pickup.when | formatTxDate}}
                      </span>
                      <span v-else-if="txn.load.tacticalInfo.scheduledPickupTime">
                        {{ txn.load.tacticalInfo.scheduledPickupTime | formatTxDate }}
                      </span>
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title>
                      {{ txn.loadHumanId }}: ${{ txn.amount }} ({{ txn.status || '[status]' }})
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-chip :color="invoiceStatusIcon(txn).color"
                            text-color="white" small>
                      <v-icon>
                        {{ invoiceStatusIcon(txn).icon }}
                      </v-icon>
                    </v-chip>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider :key="`delivered_load_txn_divider_${iidx}_${idx}_${txn.id}`"/>

              </template>
            </template>

          </v-load-nav-list>
        </template>

        <template slot="detail">
          Hey there
        </template>
      </v-master-detail-pane>
    </v-card>
  </v-layout>
</template>

<script>
import * as Timestamps from '@/types/timestamp';

import bookedLoadMixin from '@/mixins/bookedLoadMixin';
import filterLoadsMixin from '@/mixins/filterLoads';
import loadGroupMixin from '@/mixins/loadGroupMixin';
import loadTransactionsMixin from '@/mixins/loadTransactionsMixin';

import VMasterDetailPane from '@/components/MasterDetailPane';
import VLoadNavList from '@/components/dashboard/simple/LoadNavList';

import { loadStatus } from '@/types';
import _ from 'lodash';

export default {
  name: 'ApproveLoads',
  mixins: [
    bookedLoadMixin,
    filterLoadsMixin,
    loadGroupMixin,
    loadTransactionsMixin,
  ],
  components: {
    VLoadNavList,
    VMasterDetailPane,
  },
  props: {
    loadId: {
      type: String,
      required: false,
    },
    company: {
      type: Object,
    },
  },
  data: () => ({

  }),
  filters: {
    formatTxDate(dateString) {
      return dateString ? Timestamps.formattedDate(dateString) : '';
    },
  },
  watch: {
    selected() {
      if (_.get(this.selected, 'id', false)) {
        this.$router.push({ params: { loadId: this.selected.loadHumanId } });
      }
    },
    loadingTransactions() {
      if (this.$route.params.loadId) {
        this.selected = _.find(this.invoiceTransactions, { id: this.$route.params.loadId });
      }
    },
  },
  computed: {
    _() {
      return _;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    bills() {
      return _.filter(this.billTransactions, tx => this.filterLoadTransaction(tx));
    },
    invoices() {
      return _.filter(this.invoiceTransactions, tx => this.filterLoadTransaction(tx));
    },
    deliveredLoadOpenInvoices() {
      const openDeliveredSorted = _.chain(this.invoices)
        .filter(tx => this.isBookedLoadDelivered(tx.load))
        .filter(tx => this.isTransactionOpen(tx))
        .sortBy('load.pickup.when')
        .value();

      return _.groupBy(openDeliveredSorted, tx => _.get(tx, 'load.loadStatus', ''));
      // return _.groupBy(nameSorted, tx => _.get(tx, 'load.pickup.when', ''));
    },
    accurateSince() {
      if (this.loadingTransactions) {
        return 'Loading ...';
      }

      if (this.transactionsTime) {
        return `Updated ${this.$options.filters.formatTimeStamp(this.transactionsTime)}`;
      }

      return 'Refresh';
    },

    hasTransactionsPermissions() {
      // pass through to the mixin probably
      return true;
    },
  },
  methods: {
    renderEcho(thing, desc) {
      console.log(desc, thing);
      return thing;
    },
    selectLoad(txn) {
      console.log('selecting load', txn);
      if (this.isMobile && txn) {
        this.$router.push({ name: 'transaction.detail',
          params: { id: txn.loadHumanId } });
      } else {
        this.selected = txn;
      }
    },
    isSelectedLoad(txn) {
      return txn.id === _.get(this.selected, 'id', null);
    },
    bookedLoadIcon(txn) {
      return this.bookedLoadProgressIcon(txn.load);
    },
    invoiceStatusIcon(txn) {
      // let's help identify the actionable transactions
      const loadIcon = this.bookedLoadIcon(txn);
      if (txn.load.loadStatus === loadStatus.DELIVERED) {
        loadIcon.color = 'green';
      }
      return loadIcon;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/ltnplugins/approveexport/ApproveLoads.vue